export default __webpack_public_path__ + "static/media/process_0.0f5fbd70.svg";